import React, { Fragment, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";

const AdminSidebar = (props) => {
  const location = useLocation();
  const history = useHistory();
  const [open, setOpen] = useState(false);

  const navigate = (path) => {
    history.push(path);
    setOpen(false); // close drawer on navigation (mobile)
  };

  return (
    <Fragment>
      {/* Fixed mobile hamburger button at top-left */}
      <button
        onClick={() => setOpen((v) => !v)}
        aria-label={open ? "Fermer le menu admin" : "Ouvrir le menu admin"}
        className="md:hidden fixed top-3 left-3 z-50 p-2.5 rounded-lg bg-blue-800 shadow-lg hover:bg-blue-900 transition-all duration-200"
      >
        <div className="relative w-6 h-6 flex flex-col justify-center">
          {/* Hamburger to X animation */}
          <span
            className={`block w-full h-1 bg-white rounded transition-all duration-300 ${
              open ? 'rotate-45 translate-y-2' : ''
            }`}
          />
          <span
            className={`block w-full h-1 bg-white rounded my-1 transition-all duration-300 ${
              open ? 'opacity-0' : 'opacity-100'
            }`}
          />
          <span
            className={`block w-full h-1 bg-white rounded transition-all duration-300 ${
              open ? '-rotate-45 -translate-y-2' : ''
            }`}
          />
        </div>
      </button>

      {/* Overlay mobile */}
      {open && (
        <div
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-30 md:hidden transition-opacity duration-300"
          onClick={() => setOpen(false)}
          aria-hidden="true"
        />
      )}

      {/* Sidebar */}
      <div
        style={{ boxShadow: "0 8px 32px rgba(0, 0, 0, 0.15)" }}
        id="sidebar"
        className={`fixed md:sticky top-0 left-0 h-screen w-72 md:w-3/12 lg:w-2/12 bg-gradient-to-b from-white to-gray-50 text-gray-700 z-40 transform transition-all duration-300 ease-in-out md:translate-x-0 ${open ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}`}
      >
        {/* Header sidebar mobile */}
        <div className="md:hidden bg-blue-800 text-white px-4 py-6">
          <h2 className="text-lg font-bold">Menu Admin</h2>
          <p className="text-xs text-blue-100 mt-1">Gestion du site</p>
        </div>

        {/* Menu items */}
        <nav className="overflow-y-auto h-full pb-20 md:pb-0"
          style={{ scrollbarWidth: 'thin', scrollbarColor: '#cbd5e0 transparent' }}
        >
        <div
          onClick={() => navigate("/admin/dashboard")}
          className={`${
            location.pathname === "/admin/dashboard"
              ? "border-r-4 border-blue-800 bg-blue-50 text-blue-800"
              : "text-gray-700"
          } hover:bg-blue-50 hover:text-blue-800 cursor-pointer flex items-center gap-3 px-6 py-4 transition-all duration-200 group`}
        >
          <span className="group-hover:scale-110 transition-transform duration-200">
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
          </span>
          <span className="font-medium">Dashboard</span>
        </div>
        <hr className="border-gray-200 mx-4" />
        <div
          onClick={() => navigate("/admin/dashboard/categories")}
          className={`${
            location.pathname === "/admin/dashboard/categories"
              ? "border-r-4 border-blue-800 bg-blue-50 text-blue-800"
              : "text-gray-700"
          } hover:bg-blue-50 hover:text-blue-800 cursor-pointer flex items-center gap-3 px-6 py-4 transition-all duration-200 group`}
        >
          <span className="group-hover:scale-110 transition-transform duration-200">
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
              />
            </svg>
          </span>
          <span className="font-medium">Catégories</span>
        </div>
        <hr className="border-gray-200 mx-4" />
        <div
          onClick={() => navigate("/admin/dashboard/products")}
          className={`${
            location.pathname === "/admin/dashboard/products"
              ? "border-r-4 border-blue-800 bg-blue-50 text-blue-800"
              : "text-gray-700"
          } hover:bg-blue-50 hover:text-blue-800 cursor-pointer flex items-center gap-3 px-6 py-4 transition-all duration-200 group`}
        >
          <span className="group-hover:scale-110 transition-transform duration-200">
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"
              />
            </svg>
          </span>
          <span className="font-medium">Produits</span>
        </div>
        <hr className="border-gray-200 mx-4" />
        <div
          onClick={() => navigate("/admin/dashboard/gallery")}
          className={`${
            location.pathname === "/admin/dashboard/gallery"
              ? "border-r-4 border-blue-800 bg-blue-50 text-blue-800"
              : "text-gray-700"
          } hover:bg-blue-50 hover:text-blue-800 cursor-pointer flex items-center gap-3 px-6 py-4 transition-all duration-200 group`}
        >
          <span className="group-hover:scale-110 transition-transform duration-200">
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 10h16M4 14h8"
              />
            </svg>
          </span>
          <span className="font-medium">Galerie</span>
        </div>
        <hr className="border-gray-200 mx-4" />
        <div
          onClick={() => navigate("/admin/dashboard/banner")}
          className={`${
            location.pathname === "/admin/dashboard/banner"
              ? "border-r-4 border-blue-800 bg-blue-50 text-blue-800"
              : "text-gray-700"
          } hover:bg-blue-50 hover:text-blue-800 cursor-pointer flex items-center gap-3 px-6 py-4 transition-all duration-200 group`}
        >
          <span className="group-hover:scale-110 transition-transform duration-200">
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 5h18M3 12h18M3 19h18"
              />
            </svg>
          </span>
          <span className="font-medium">Bannière promo</span>
        </div>
        </nav>
      </div>
    </Fragment>
  );
};

export default AdminSidebar;
